import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SEOService } from 'src/app/shared/seo.service';

@Component({
  selector: 'app-index-car-riding',
  templateUrl: './index-car-riding.component.html',
  styleUrls: ['./index-car-riding.component.css']
})
export class IndexCarRidingComponent implements OnInit {

  constructor(private seoService:SEOService) { }

  ngOnInit(): void {

    this.setMeta();
  }

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      900: {
        items: 1
      }
    },
    nav: false
  };


  setMeta() {
    var desc;
    var keys;
    var title

    keys = 'Pratiu Eğitim Kurumları, Eğitim Kurumları';
    title = 'pratiu - Eğitim / Öğretim Kurumları';
    desc = title;

    this.seoService.updateDescription(desc);
    this.seoService.updateKeywords(keys);
    this.seoService.updateTitle(title); 
  }


}
